import { createContext, useContext, useState, useEffect } from 'react';
import { termsLabelList } from '../../consts/terms';
import useBusinessNumber from './hooks/useBusinessNumber';

const ESignContext = createContext();

export const useESign = () => {
  const ctx = useContext(ESignContext);
  if (!ctx) throw new Error('useESign must be used within ESignProvider');
  return ctx;
};

const STORAGE_KEY = 'esign_checked_list';

const getInitCheckList = () => {
  // 모두 false로 초기화
  return termsLabelList.map(() => false);
};

const loadCheckedList = (businessNumber) => {
  const saved = localStorage.getItem(STORAGE_KEY);

  if (!saved) {
    return getInitCheckList();
  }

  try {
    const parsed = JSON.parse(saved);
    // businessNumber가 같을 때만 기존 데이터 사용
    if (parsed.businessNumber === businessNumber) {
      return parsed.checkedList;
    }

    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('Failed to parse localStorage', e);
  }

  return getInitCheckList();
};

export const ESignProvider = ({ children }) => {
  const { businessNumber } = useBusinessNumber();
  const [checkedList, setCheckedList] = useState(() => loadCheckedList(businessNumber));
  const [prevBusinessNumber, setPrevBusinessNumber] = useState(null);

  // checkedList 바뀔 때마다 저장 (유캔사인에서 돌아올 때, 동의 항목 유지하기 위해)
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ businessNumber, checkedList }));
  }, [checkedList]);

  useEffect(() => {
    if (prevBusinessNumber && prevBusinessNumber != businessNumber) {
      setCheckedList(getInitCheckList());
    }

    setPrevBusinessNumber(businessNumber);
  }, [businessNumber]);

  const toggleChecked = (index) => {
    setCheckedList((prev) => {
      const newCheckedList = [...prev];
      newCheckedList[index] = !newCheckedList[index];
      return newCheckedList;
    });
  };

  // 전체 선택 / 해제
  const toggleAllChecked = () => {
    setCheckedList((prev) => prev.map(() => !checkedList.every(Boolean)));
  };

  return (
    <ESignContext.Provider
      value={{
        checkedList,
        toggleChecked,
        toggleAllChecked,
      }}
    >
      {children}
    </ESignContext.Provider>
  );
};
